<textarea
  [formControl]="formControl"
  class="hmm-input tw-w-full"
  [formlyAttributes]="field"
></textarea>
<small>
  {{ formControl.value?.length ?? 0 }}
  @if (props.description) {
    -
  }
</small>
